import { ReactNode, useEffect, useRef, useState } from "react";
import Intro from "../Intro";
import {
  PensionProductType,
  PensionProductTypeData,
} from "../../data/PensionProductType";
import MobileSidebar from "../sidebar/mobile/MobileSidebar";
import { TableType } from "../../data/TableType";
import { TextContainer, Paragraph, Card } from "frno-react";
import DynamicText from "../common/DynamicText";
import useTextStore from "../../state/TextStore";
import useApplicationStore from "../../state/ApplicationStore";

type PageWrapperProps = {
  pensionProductType: PensionProductType;
  children: ReactNode;
  tableType: TableType;
  tableTypeKey: string;
};
export default function TablePageWrapper({
  children,
  pensionProductType,
  tableType,
  tableTypeKey,
}: PageWrapperProps) {
  const { getTextByKey } = useTextStore();
  const { selectedCompany } = useApplicationStore();

  const prevProductType = useRef(pensionProductType);

  const [infoCardState, setState] = useState({
    canShowInfoCard: true,
    showInfoCard: selectedCompany.length > 0,
  });

  useEffect(() => {
    setState((prevInfoCardState) => ({
      ...prevInfoCardState,
      showInfoCard: selectedCompany.length > 0,
    }));
  }, [selectedCompany]);

  useEffect(() => {
    if (prevProductType.current !== pensionProductType) {
      setState((prevInfoCardState) => ({
        ...prevInfoCardState,
        canShowInfoCard: true,
      }));
    }
    prevProductType.current = pensionProductType;
  }, [pensionProductType]);

  return (
    <div className="flex-1 ml-8 ml-md-0">
      <Intro
        pensionType={PensionProductTypeData[pensionProductType].displayName}
      />

      <MobileSidebar
        pensionType={PensionProductTypeData[pensionProductType].displayName}
        tableType={tableType}
      />

      <TextContainer>
        <Paragraph className="mt-6">
          <DynamicText textKey={`page.${tableTypeKey}.table.info`} />
        </Paragraph>
      </TextContainer>

      {infoCardState.showInfoCard && infoCardState.canShowInfoCard && (
        <Card
          className="mt-6"
          tag="h4"
          title={getTextByKey("page.common.table.feeinfo.header")}
          icon="fa-circle-exclamation"
          bg="yellow-20"
          text={getTextByKey("page.common.table.feeinfo.content")}
          closeable={{
            onClose: () =>
              setState({ showInfoCard: false, canShowInfoCard: false }),
            ariaLabelText: getTextByKey("page.fund.card.button.aria-close"),
          }}
        />
      )}
      {children}
    </div>
  );
}
